export type MedcallMedicationStrengthSelectionOption = {
  name?: string | null;
  strength?: string | null;
};

type MedcallStoredMedicationReference = {
  drugbankPcid?: string | null;
  medicineDetail?: Array<{
    drugbank_pcid?: string | null;
    external_id?: string | null;
    uuid?: string | null;
  }> | null;
  pharmabankUuid?: string | null;
  uuid?: string | null;
};

const normalizeCatalogValue = (value: unknown) => `${value || ''}`.trim();

export const getMedcallStrengthOptionValue = (option: MedcallMedicationStrengthSelectionOption) => (
  normalizeCatalogValue(option.strength) || normalizeCatalogValue(option.name)
);

export const getMedcallStrengthOptionLabel = (option: MedcallMedicationStrengthSelectionOption) => (
  normalizeCatalogValue(option.name) || normalizeCatalogValue(option.strength)
);

export const resolveMedcallStoredStrength = (
  options: MedcallMedicationStrengthSelectionOption[],
  selectedValue: string
) => {
  const normalizedSelectedValue = normalizeCatalogValue(selectedValue);
  const selectedOption = options.find((option) => (
    getMedcallStrengthOptionValue(option) === normalizedSelectedValue
      || getMedcallStrengthOptionLabel(option) === normalizedSelectedValue
  ));
  return selectedOption ? getMedcallStrengthOptionLabel(selectedOption) : normalizedSelectedValue;
};

export const resolveMedcallStrengthControlValue = (
  options: MedcallMedicationStrengthSelectionOption[],
  storedStrength: string
) => {
  const normalizedStoredStrength = normalizeCatalogValue(storedStrength);
  const selectedOption = options.find((option) => (
    getMedcallStrengthOptionLabel(option) === normalizedStoredStrength
      || getMedcallStrengthOptionValue(option) === normalizedStoredStrength
  ));
  return selectedOption ? getMedcallStrengthOptionValue(selectedOption) : normalizedStoredStrength;
};

export const sortMedcallStrengthOptionsNumerically = <T extends MedcallMedicationStrengthSelectionOption>(
  options: T[]
) => [...options].sort((left, right) => (
  Number.parseFloat(getMedcallStrengthOptionValue(left) || '0')
    - Number.parseFloat(getMedcallStrengthOptionValue(right) || '0')
));

export const resolveStoredMedicationExternalId = (reference: MedcallStoredMedicationReference) => {
  const detail = Array.isArray(reference.medicineDetail) ? reference.medicineDetail[0] : null;
  return normalizeCatalogValue(detail?.external_id)
    || normalizeCatalogValue(detail?.drugbank_pcid)
    || normalizeCatalogValue(reference.drugbankPcid)
    || normalizeCatalogValue(reference.uuid)
    || normalizeCatalogValue(detail?.uuid)
    || normalizeCatalogValue(reference.pharmabankUuid);
};
